<!-- 추후에 공통모달로 변경예정 -->

<template>
  <v-dialog v-model="dialog" persistent max-width="900px">
    <!--
        <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>
        -->
    <v-card style="min-width:900px;">
      <div class="d-flex justify-content-between pl-7">
        <v-card-title outline="true" class="custom-modal-header">
          <div class="headline w-100">{{ $t("ShowCompanyProfile") }}</div>
        </v-card-title>
        <v-btn class="m-5" color="blue darken-1" text @click="$emit('close')"
        >X</v-btn
        >
      </div>
      <!--
            <v-card-title>P
                <span class="headline">Company Profile</span>
            </v-card-title>
            -->
      <v-card-text>
        <template>
          <!-- b-tabs의 클래스 요소 content-class="mt-3" -->
          <b-tabs card>
            <b-tab :title="$t('Representative')" active>
              <v-container>
                <v-row>
                  <form class="form w-100" >
                    <!--begin: Wizard Step 1-->
                    <div
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                    >

                      <b-row>
                        <b-col>
                          <b>{{ $t("RepresentativeStatus") }}</b>
                          <!--                      <small>( "Proof of delegated authority" Exclusion )</small>-->

                          <v-chip class="ma-2" :color="KYB_STATUS_COLOR[representative.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[representative.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                      <div class="row">
                        <div class="col-lg-3">
                          <div class="d-flex align-items-center h-100">
                            <div class="symbol symbol-40 mr-5 symbol-light-warning" >
                                      <span class="symbol-label">
                                        <span class="svg-icon svg-icon-lg" :class="`svg-icon-success`" >
                                          <b-icon-building></b-icon-building>
                                        </span>
                                      </span>
                            </div>
                            <div class="d-flex flex-column font-weight-bold">
                                <span class="text-dark text-hover-primary mb-1 font-size-lg">
                                  {{ $t("FullName") }}
                                </span>
                              <span class="text-muted">
                                  {{representative.name || '-'}}
<!--                                {{representative.ceoName || '-'}}-->
                                </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="d-flex align-items-center h-100">
                            <div class="symbol symbol-40 mr-5 symbol-light-primary" >
                                      <span class="symbol-label">
                                        <span class="svg-icon svg-icon-lg" :class="`svg-icon-success`" >
                                          <b-icon-calendar></b-icon-calendar>
                                        </span>
                                      </span>
                            </div>
                            <div class="d-flex flex-column font-weight-bold">
                                      <span class="text-dark text-hover-primary mb-1 font-size-lg">
                                        {{ $t("DateOfBirth") }}
                                      </span>
                              <span class="text-muted">
                                <template v-if="$i18n.locale === 'ko'">
                                  {{representative.dateOfBirth ? $moment(representative.dateOfBirth).format('YYYY년 MM월 DD일') : '-'}}
                                </template>
                                <template v-else-if="$i18n.locale === 'en'">
                                  {{representative.dateOfBirth ? convertDateFormat($moment(representative.dateOfBirth).format('YYYY-MM-DD')) : '-'}}
                                </template>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="d-flex align-items-center h-100">
                            <div class="symbol symbol-40 mr-5 symbol-light-success" >
                                        <span class="symbol-label">
                                          <span class="svg-icon svg-icon-lg" v-bind:class="`svg-icon-success`" >
                                            <b-icon-map></b-icon-map>
                                          </span>
                                        </span>
                            </div>
                            <div class="d-flex flex-column font-weight-bold">
                                        <span class="text-dark text-hover-primary mb-1 font-size-lg">
                                          {{ $t("Nationality") }}
                                        </span>
                              <span class="text-muted">
                                          {{representative.nationality.toUpperCase() || '-'}}
                                        </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="d-flex align-items-center h-100">
                            <template>
                              <v-radio-group v-model="selected" column readonly disabled>
                                <v-radio  v-for="item in options" v-bind:key="item.value"
                                          :label="$t(item.text)"
                                          color="orange"
                                          :value="item.value"
                                ></v-radio>
                              </v-radio-group>
                            </template>
                          </div>
                        </div>

                        <div class="col-sm-12 col-lg-6">
                          <div class="form-group mb-0 px-1">
                            <v-card class="mx-auto">
                              <v-card-title class="border-bottom font-weight-bold" style="">
                                {{ $t("ID Card") }}
                              </v-card-title>
                              <!--
                              <v-card-text class="text-primary" style="height: 300px;">
                              </v-card-text>
                              -->
                              <v-card-text style="position:relative; height:250px; line-height:250px;" class="text-center">
                                <b-img  class="vertical" :src="representative.idCardUrl" fluid style="object-fit:contain; height:100%"></b-img>
                              </v-card-text>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </v-row>
              </v-container>
            </b-tab>



            <b-tab :title="$t('CompanyProfileDocument')">
              <v-container>
                <b-row>
                  <b-col cols="12" v-show="isDocsEmpty">
                    <div style="height:200px; line-height:200px;" class="text-center">{{$t("TheFileDoesNotExist")}}</div>
                  </b-col>

                  <b-col cols="6" v-if="businessDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Business Docs") }}</label>
                      <!--
                      <b-form-input class="d-inline-block" style="width:250px;"
                                    placeholder="Enter your name"
                      ></b-form-input>
                      -->
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank"
                             v-for="( item, index ) in businessDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[businessDocs.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[businessDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                      <!--
                      <v-chip class="ma-2" color="gray">
                        Pending
                      </v-chip>
                      -->
                    </div>
                  </b-col>
                  <b-col cols="6" v-if="corporateDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Corporate Docs") }}</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank" v-for="( item, index ) in getFileList('corporateDocs')" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[corporateDocs.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[corporateDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                      <!--
                      <v-chip class="ma-2" color="gray">
                        Pending
                      </v-chip>
                      -->
                    </div>
                  </b-col>
                  <b-col cols="6" v-if="directorsDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Directors Docs") }}</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank" v-for="( item, index ) in directorsDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[directorsDocs.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[directorsDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col cols="6" v-if="shareholderDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Shareholder Docs") }}</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a v-for="( item, index ) in shareholderDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[shareholderDocs.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[shareholderDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col cols="6" v-if="associationDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Association") }}</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank" v-for="( item, index ) in associationDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[associationDocs.status]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[associationDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                      <!--
                      <v-chip class="ma-2" color="gray">
                        Pending
                      </v-chip>
                      -->
                    </div>
                  </b-col>


                  <b-col cols="6" v-if="businessAddressDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">{{ $t("Business Address") }}</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank" v-for="( item, index ) in businessAddressDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            {{ $t("Download File") }}
                          </a>
                          <div v-if="businessAddressDocs.address">
                            <span>{{ businessAddressDocs.address }}</span>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[ businessAddressDocs.status ]" text-color="white">
                            {{$t(KYB_PROJECT_STATUS_TEXT[businessAddressDocs.status])}}
                          </v-chip>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>

                  <b-col cols="6" v-if="principalAddressDocs.fileList.length > 0">
                    <div class="form-group">
                      <label class="font-weight-bold w-100">Principal Address</label>
                      <b-row class="pt-2">
                        <b-col class="file-list-area">
                          <a target="_blank" v-for="( item, index ) in principalAddressDocs.fileList" :key="index"
                             class="text-decoration-underline w-100" @click="downloadFile(item)">
                            Download File
                          </a>
                          <div v-if="principalAddressDocs.address">
                            <span>{{ principalAddressDocs.address }}</span>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <v-chip :color="KYB_STATUS_COLOR[ principalAddressDocs.status ]" text-color="white">
                            {{KYB_PROJECT_STATUS_TEXT[principalAddressDocs.status]}}
                          </v-chip>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>


                </b-row>
              </v-container>



            </b-tab>
          </b-tabs>

        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
.tab-item {
  min-height: 500px;
}
</style>
<script>
export default {

  props : {
    companyProfileInfo: {
      type: Object,
      default: function () {
        return {
        }
      }
    }
  },

  computed : {

    KYB_PROJECT_STATUS_TEXT() {
      return this.$store.state.KYB_PROJECT_STATUS_TEXT;
    },

    KYB_STATUS_COLOR() {
      return this.$store.state.KYB_STATUS_COLOR;
    },

    ceoText () {

      return this.$store.state.kybModule.represent[this.representative.representType]
    },
    isDocsEmpty() {
      return (
          this.businessDocs.fileList.length == 0 &&
          this.corporateDocs.fileList.length == 0 &&
          this.directorsDocs.fileList.length == 0 &&
          this.shareholderDocs.fileList.length == 0 &&
          this.associationDocs.fileList.length == 0 &&
          this.businessAddressDocs.fileList.length == 0 &&
          this.principalAddressDocs.fileList.length == 0
      );
    },
    /**
     * 파일구조 초기화 시작 : company profile document data에 대한 초기값 처리 내용입니다.
     * 형식은
     * {
     *    businessDocs : {
     *      fileList: ["https://businessFile.com", "https://businessFile2.com"] // 현재는 하나의 파일만 취급합니다
     *      status: "approved"
     *    }, ...
     * }
     */
    businessDocs() {
      if( !this.companyProfile.businessDocs || !this.companyProfile.businessDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.businessDocs;
    },
    corporateDocs() {
      if( !this.companyProfile.corporateDocs || !this.companyProfile.corporateDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.corporateDocs;
    },
    directorsDocs() {
      if( !this.companyProfile.directorsDocs || !this.companyProfile.directorsDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.directorsDocs;
    },
    shareholderDocs() {
      if( !this.companyProfile.shareholderDocs || !this.companyProfile.shareholderDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.shareholderDocs;
    },
    associationDocs() {
      if( !this.companyProfile.associationDocs || !this.companyProfile.associationDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.associationDocs;
    },
    businessAddressDocs() {
      if( !this.companyProfile.businessAddressDocs || !this.companyProfile.businessAddressDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.businessAddressDocs;
    },
    principalAddressDocs() {
      if( !this.companyProfile.principalAddressDocs || !this.companyProfile.principalAddressDocs.fileList ) {
        return this.initFileObject;
      }
      return this.companyProfile.principalAddressDocs;
    },
    /** 파일구조 초기화 끝 */

    companyProfile : function() {
      return this.companyProfileInfo.companyProfile ? this.companyProfileInfo.companyProfile : {};
    },
    representative : function() {
      return this.companyProfileInfo.representative ? this.companyProfileInfo.representative : {};
    },
    selected : function() {
      if( !this.companyProfileInfo.representative || !this.companyProfileInfo.representative.representType ) {
        return "null"
      }
      return this.companyProfileInfo.representative.representType;
    }
  },
  data() {
    return {

      initFileObject : { fileList : [], status : ""},  //file 초기구조입니다. (데이터가 없는 경우 에러가 날 수 있으니 사용)
      //selected: null,
      radioGroup: 't',
      options: [
        { text: 'Not Selected', value: "null" },
        { text: 'Ceo', value: 'ceo' },
        { text: 'Delegate', value: 'delegate' },
      ],
      kybStatusOptions : [
        { text: "Pending", value: "Pending" },
        { text: "Approved", value: "Approved" }
      ],
      //selected: "Delegate",
      /*
      companyProfileInfo: {
        fullName: "hong gildong",
        dateOfBirth: "1972-07-08",
        nationality: "KOR",
        formId: ""
      },
      */
      items: ["Delegate", "Attorney"],
      dialog: true,
      tab: null,
    };
  },
  components: {
    //KTCodePreview
  },
  mounted() {
    console.log( "$store.state", this.$store.state )
    console.log("this.companyProfileInfo", this.companyProfileInfo);
    console.log("this.representative", this.representative);
  },
  methods: {

    /**
     * 파일url을 이용하여 파일명을 가져옵니다.
     */
    getFileName( fileUrl ) {
      return fileUrl.split("/").pop();
    },
    downloadFile(url){
      this.$store.dispatch('downloadFile', {url: url});
    },

    /**
     * validation 삽입 (그냥 객체로 가져올 시 빈 객체로 인해 undefined에러가 발생할 수 있습니다.
     * @param key
     * @returns {*[]|*}
     */
    getFileList ( key ) {
      console.log("key in getFileList", key);
      console.log("companyProfile in getFileList", this.companyProfile);
      if( !key ) {
        console.log( "잘못된 호출입니다. param ::: ", key );
        return [];
      }

      let obj = this.companyProfile[key];

      if( !obj || !obj.fileList ) {
        return [];
      }
      if( obj.fileList.length > 0 ) {
        console.log("obj.fileList", obj.fileList);
        return obj.fileList ;
      }
    },

    //    관리자페이지에서만 보이는 text
    isConsole() {
      return this.$route.path.includes( "console" );
    },
    convertDateFormat(date){
      if(date.indexOf(' ') > -1){
        let newDate = new Date(date.split(' ')[0]).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2] + ' ' + date.split(' ')[1];
      }else{
        let newDate = new Date(date).toString();
        let dateArr = newDate.split(' ');
        return dateArr[3] + '. ' + dateArr[1] + ' ' + dateArr[2];
      }
    }
  },
};
</script>
<style scoped>

.file-list-area a {
  display: inline-block;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 230px !important;
}
</style>
